'use client';

import { c as _c } from "react/compiler-runtime";
import { getAriaLabel } from '@bridge/utils';
import { AmountInput } from '../../components/AmountInput';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { AmountInputProps } from '../../components/AmountInput';
import type { BaseFieldProps } from './types';
export type AmountInputComponentProps = Omit<AmountInputProps, 'value' | 'onChange'>;
interface AmountInputFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: AmountInputComponentProps;
}
export function AmountInputField(t0) {
  const $ = _c(25);
  const {
    field,
    fieldConfig,
    fieldState,
    componentProps,
    labelSize
  } = t0;
  let componentDisabled;
  let id;
  let restComponentProps;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      ...restComponentProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = id;
    $[3] = restComponentProps;
  } else {
    componentDisabled = $[1];
    id = $[2];
    restComponentProps = $[3];
  }
  const isDisabled = field.disabled || componentDisabled;
  let t1;
  if ($[4] !== fieldConfig || $[5] !== fieldState || $[6] !== id) {
    t1 = getFieldIds(fieldConfig, fieldState, id);
    $[4] = fieldConfig;
    $[5] = fieldState;
    $[6] = id;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const ids = t1;
  const t2 = ids.describedBy;
  const t3 = ids.isInvalid;
  let t4;
  if ($[8] !== fieldConfig.label) {
    t4 = getAriaLabel(fieldConfig.label);
    $[8] = fieldConfig.label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = field.value ?? "";
  let t6;
  if ($[10] !== field.onChange || $[11] !== ids.describedBy || $[12] !== ids.fieldId || $[13] !== ids.isInvalid || $[14] !== isDisabled || $[15] !== restComponentProps || $[16] !== t4 || $[17] !== t5) {
    t6 = <AmountInput {...restComponentProps} aria-describedby={t2} aria-invalid={t3} aria-label={t4} disabled={isDisabled} id={ids.fieldId} onChange={field.onChange} value={t5} />;
    $[10] = field.onChange;
    $[11] = ids.describedBy;
    $[12] = ids.fieldId;
    $[13] = ids.isInvalid;
    $[14] = isDisabled;
    $[15] = restComponentProps;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== fieldConfig || $[20] !== fieldState || $[21] !== ids || $[22] !== labelSize || $[23] !== t6) {
    t7 = <FieldShell fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t6}</FieldShell>;
    $[19] = fieldConfig;
    $[20] = fieldState;
    $[21] = ids;
    $[22] = labelSize;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}